module.exports = __webpack_public_path__ + "img/arrow-right.7b9f1843.svg";